module.exports = __webpack_public_path__ + "media/entities/1304-025b0702.png";